import type { Template } from "@/types";

export const PO_07_H4_V3: Template[] = [
{
    id: "po-07-h4v3-01",
    name: "PO 01 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_01.png",
    size: [1136, 854],
    style: {},
    slots: [          
        { id: "1", x: 44, y: 238, width: 237, height: 186, rotation: 0, imageRotation: 0 },
        { id: "2", x: 44, y: 432, width: 237, height: 186, rotation: 0, imageRotation: 0 },
        { id: "3", x: 289, y: 238, width: 236, height: 186, rotation: 0, imageRotation: 0 },
        { id: "4", x: 289, y: 432, width: 236, height: 186, rotation: 0, imageRotation: 0 },
        { id: "5", x: 612, y: 163, width: 317, height: 529, rotation: 0, imageRotation: 0 },
        { id: "6", x: 937, y: 163, width: 155, height: 261, rotation: 0, imageRotation: 0 },
        { id: "7", x: 937, y: 432, width: 155, height: 260, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-02",
    name: "PO 02 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 55, y: 162, width: 460, height: 349, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 55, y: 519, width: 226, height: 172, rotation: 0, imageRotation: 0 },
        { id: "3", x: 289, y: 519, width: 226, height: 172, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 112, width: 480, height: 361, rotation: 0, imageRotation: 0 },
        { id: "5", x: 613, y: 481, width: 155, height: 260, rotation: 0, imageRotation: 0 },
        { id: "6", x: 776, y: 481, width: 154, height: 260, rotation: 0, imageRotation: 0 },
        { id: "7", x: 938, y: 481, width: 154, height: 260, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-03",
    name: "PO 03 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 44, y: 248, width: 480, height: 359, rotation: 0, imageRotation: 0 },   
        { id: "2", x: 612, y: 248, width: 155, height: 115, rotation: 0, imageRotation: 0 },
        { id: "3", x: 612, y: 371, width: 155, height: 114, rotation: 0, imageRotation: 0 },
        { id: "4", x: 612, y: 493, width: 155, height: 114, rotation: 0, imageRotation: 0 },
        { id: "5", x: 775, y: 248, width: 200, height: 359, rotation: 0, imageRotation: 0 },
        { id: "6", x: 983, y: 248, width: 109, height: 176, rotation: 0, imageRotation: 0 },
        { id: "7", x: 983, y: 432, width: 109, height: 175, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-04",
    name: "PO 04 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 48, y: 162, width: 480, height: 407, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 48, y: 577, width: 155, height: 115, rotation: 0, imageRotation: 0 },
        { id: "3", x: 211, y: 577, width: 155, height: 115, rotation: 0, imageRotation: 0 },
        { id: "4", x: 374, y: 577, width: 154, height: 115, rotation: 0, imageRotation: 0 },
        { id: "5", x: 595, y: 139, width: 341, height: 577, rotation: 0, imageRotation: 0 },
        { id: "6", x: 944, y: 139, width: 165, height: 284, rotation: 0, imageRotation: 0 },
        { id: "7", x: 944, y: 431, width: 165, height: 284, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-05",
    name: "PO 05 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 43, y: 167, width: 481, height: 349, rotation: 0, imageRotation: 0 },
        { id: "2", x: 43, y: 524, width: 237, height: 163, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 524, width: 237, height: 163, rotation: 0, imageRotation: 0 },
        { id: "4", x: 608, y: 133, width: 481, height: 349, rotation: 0, imageRotation: 0 },
        { id: "5", x: 608, y: 490, width: 155, height: 230, rotation: 0, imageRotation: 0 },
        { id: "6", x: 771, y: 490, width: 155, height: 230, rotation: 0, imageRotation: 0 },
        { id: "7", x: 934, y: 490, width: 155, height: 230, rotation: 0, imageRotation: 0 }   
    ],
},

{
    id: "po-07-h4v3-06",
    name: "PO 06 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 43, y: 227, width: 482, height: 279, rotation: 0, imageRotation: 0 },
        { id: "2", x: 43, y: 513, width: 156, height: 114, rotation: 0, imageRotation: 0 },
        { id: "3", x: 206, y: 513, width: 156, height: 114, rotation: 0, imageRotation: 0 },
        { id: "4", x: 369, y: 513, width: 156, height: 114, rotation: 0, imageRotation: 0 },
        { id: "5", x: 651, y: 227, width: 252, height: 400, rotation: 0, imageRotation: 0 },
        { id: "6", x: 911, y: 227, width: 125, height: 196, rotation: 0, imageRotation: 0 },
        { id: "7", x: 911, y: 431, width: 125, height: 196, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-07",
    name: "PO 07 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 26, y: 227, width: 517, height: 400, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 592, y: 227, width: 170, height: 128, rotation: 0, imageRotation: 0 },
        { id: "3", x: 592, y: 363, width: 170, height: 128, rotation: 0, imageRotation: 0 },
        { id: "4", x: 592, y: 499, width: 170, height: 128, rotation: 0, imageRotation: 0 },
        { id: "5", x: 770, y: 227, width: 224, height: 400, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1002, y: 227, width: 107, height: 196, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1002, y: 431, width: 107, height: 196, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-08",
    name: "PO 08 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 244, width: 211, height: 366, rotation: 0, imageRotation: 0 },
        { id: "2", x: 219, y: 244, width: 236, height: 179, rotation: 0, imageRotation: 0 },
        { id: "3", x: 219, y: 431, width: 236, height: 179, rotation: 0, imageRotation: 0 },
        { id: "4", x: 463, y: 244, width: 211, height: 366, rotation: 0, imageRotation: 0 },
        { id: "5", x: 926, y: 244, width: 211, height: 366, rotation: 0, imageRotation: 0 },       
        { id: "6", x: 682, y: 244, width: 236, height: 179, rotation: 0, imageRotation: 0 },
        { id: "7", x: 682, y: 431, width: 236, height: 179, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-09",
    name: "PO 09 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 244, width: 240, height: 179, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 431, width: 240, height: 179, rotation: 0, imageRotation: 0 },
        { id: "3", x: 248, y: 244, width: 208, height: 366, rotation: 0, imageRotation: 0 },
        { id: "4", x: 464, y: 244, width: 208, height: 366, rotation: 0, imageRotation: 0 },
        { id: "5", x: 680, y: 244, width: 208, height: 366, rotation: 0, imageRotation: 0 },
        { id: "6", x: 896, y: 244, width: 240, height: 179, rotation: 0, imageRotation: 0 },
        { id: "7", x: 896, y: 431, width: 240, height: 179, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-10",
    name: "PO 10 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 73, y: 102, width: 421, height: 322, rotation: 0, imageRotation: 0 },
        { id: "2", x: 73, y: 432, width: 421, height: 321, rotation: 0, imageRotation: 0 },
        { id: "3", x: 502, y: 102, width: 420, height: 322, rotation: 0, imageRotation: 0 },
        { id: "4", x: 502, y: 432, width: 420, height: 321, rotation: 0, imageRotation: 0 },
        { id: "5", x: 930, y: 102, width: 134, height: 212, rotation: 0, imageRotation: 0 },
        { id: "6", x: 930, y: 322, width: 134, height: 212, rotation: 0, imageRotation: 0 },
        { id: "7", x: 930, y: 542, width: 134, height: 211, rotation: 0, imageRotation: 0 }
    ],
}
];